export default "__VITE_ASSET__D3C2WeP1__";